import { render, staticRenderFns } from "./guard_witness_view.vue?vue&type=template&id=0df16ea4&scoped=true"
import script from "./guard_witness_view.vue?vue&type=script&lang=js"
export * from "./guard_witness_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df16ea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0df16ea4')) {
      api.createRecord('0df16ea4', component.options)
    } else {
      api.reload('0df16ea4', component.options)
    }
    module.hot.accept("./guard_witness_view.vue?vue&type=template&id=0df16ea4&scoped=true", function () {
      api.rerender('0df16ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/guardWitness/guard_witness_view.vue"
export default component.exports